import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { Shield } from 'lucide-react';

interface SecurityStatusProps {
  twoFactorEnabled: boolean;
  lastLogin?: string;
  activeSessions?: number;
}

const SecurityStatus = ({
  twoFactorEnabled,
  lastLogin = '2 hours ago',
  activeSessions = 3,
}: SecurityStatusProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center space-x-2 text-base sm:text-lg">
          <Shield className="h-5 w-5 flex-shrink-0" />
          <span>Security Status</span>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-3">
          <div className="flex items-center justify-between gap-2">
            <span className="text-sm truncate">Password Strength</span>
            <Badge variant="secondary">Strong</Badge>
          </div>
          <div className="flex items-center justify-between gap-2">
            <span className="text-sm truncate">2FA Status</span>
            <Badge variant={twoFactorEnabled ? 'default' : 'secondary'}>
              {twoFactorEnabled ? 'Enabled' : 'Disabled'}
            </Badge>
          </div>
          <div className="flex items-center justify-between gap-2">
            <span className="text-sm truncate">Last Login</span>
            <span className="text-sm text-muted-foreground">{lastLogin}</span>
          </div>
          <div className="flex items-center justify-between gap-2">
            <span className="text-sm truncate">Active Sessions</span>
            <span className="text-sm text-muted-foreground">
              {activeSessions}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SecurityStatus;
